import React, {
    useState,
    useEffect,
} from "react"
import { ChartStackedCategoryBars } from './ot'

const BaseChart1 = ({
    showComponent = [
        "ChartStackedCategoryBars",
    ],
    baseChartStackedCategoryBars = {
        title: "分類與建立方式分佈",
        data: [
            {
                title: "行銷",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
            {
                title: "銷售",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
            {
                title: "報告",
                data: [
                    { label: "手動", value: 8, color: "text-blue-600", bgColor: "bg-blue-500" },
                    { label: "系統", value: 12, color: "text-purple-600", bgColor: "bg-purple-500" },
                    { label: "智慧", value: 4, color: "text-blue-600", bgColor: "bg-blue-600" },
                ]
            },
        ],
    },
}, ref) => {
    return (
        <>
            {
                showComponent.includes("ChartStackedCategoryBars") && (
                    <ChartStackedCategoryBars {...baseChartStackedCategoryBars} />
                )
            }
        </>
    )
}

export default BaseChart1
